var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLockSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6721 18.7541V17.7083C19.6721 16.5577 18.7547 15.625 17.6229 15.625C16.4912 15.625 15.5738 16.5577 15.5738 17.7083V18.7541M10.4508 21.875H4.30328C4.30328 17.8479 7.51434 14.5833 11.4754 14.5833C11.8232 14.5833 12.1654 14.6085 12.5 14.6572M16.0861 21.875H19.1598C19.6372 21.875 19.8759 21.875 20.0642 21.7957C20.3152 21.69 20.5148 21.4872 20.6188 21.232C20.6967 21.0405 20.6967 20.7978 20.6967 20.3125C20.6967 19.8272 20.6967 19.5845 20.6188 19.393C20.5148 19.1378 20.3152 18.935 20.0642 18.8292C19.8759 18.75 19.6372 18.75 19.1598 18.75H16.0861C15.6087 18.75 15.37 18.75 15.1817 18.8292C14.9307 18.935 14.7311 19.1378 14.6272 19.393C14.5492 19.5845 14.5492 19.8272 14.5492 20.3125C14.5492 20.7978 14.5492 21.0405 14.6272 21.232C14.7311 21.4872 14.9307 21.69 15.1817 21.7957C15.37 21.875 15.6087 21.875 16.0861 21.875ZM15.5738 7.29167C15.5738 9.59287 13.7388 11.4583 11.4754 11.4583C9.21193 11.4583 7.37705 9.59287 7.37705 7.29167C7.37705 4.99046 9.21193 3.125 11.4754 3.125C13.7388 3.125 15.5738 4.99046 15.5738 7.29167Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLockSvgrepo);
export default __webpack_public_path__ + "static/media/user-lock-svgrepo.b2f372dcf546a3d56eaaab6a515ee265.svg";
export { ForwardRef as ReactComponent };